import makeStyles from '@material-ui/core/styles/makeStyles';
import { useState, SyntheticEvent } from 'react';

import { IconButton, Menu, MenuItem, Typography } from '@material-ui/core';
import { DotsVertical } from '@eduzz/houston-icons';
import useImageFallback from 'hooks/useImageFallback';
import ShowcaseCard from 'components/Courses/Shelves/Card';

import RegisterElasticCertificateEvent from 'services/registerElasticCertificateEvent';

interface IProps {
  title: string;
  id: number;
  image: string;
  url: string;
  courseHash: string;
  progress?: number;
}

const useStyles = makeStyles((theme) => ({
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    '& .houston-icon': {
      color: theme.palette.common.white,
    },
    '& button': {
      padding: 0,
    },
  },
  title: {
    '@media(max-width: 1440px)': {
      fontSize: 14,
    },
    height: 20,
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.common.white,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    width: '100%',
  },
  menu: {
    background: theme.palette.dark[600],
    boxShadow: 'rgba(0, 0, 0, 0.8) 0px 20px 30px',
    overflow: 'visible',
    '&:after': {
      content: "''",
      position: 'absolute',
      backgroundColor: 'transparent',
      borderLeft: '10px solid transparent',
      borderRight: '10px solid transparent',
      borderBottom: `10px solid ${theme.palette.dark[600]}`,
      top: -8,
      left: 13,
    },
    '& li, span, a': {
      fontSize: 14,
      color: theme.palette.common.white,
    },
  },
}));

const Card = (props: IProps) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const registerElasticCertificateEvent = new RegisterElasticCertificateEvent(
    props.courseHash,
    props.progress,
    props.url,
    props.title
  ).emit;

  const imageProps = useImageFallback(props.image, require(`assets/img/nutror-card-${props.id % 5}.png`));
  const classes = useStyles();

  const handleOpenCertificate = (event: SyntheticEvent) => {
    event.stopPropagation();
    event.preventDefault();
    closeMenu();
    registerElasticCertificateEvent();
  };

  const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = (event?: SyntheticEvent) => {
    if (event) {
      event.stopPropagation();
    }
    setAnchorEl(null);
  };

  return (
    <ShowcaseCard id={0} {...imageProps} onClick={handleOpenCertificate}>
      <div className={classes.titleContainer}>
        <Typography className={classes.title}>{props.title}</Typography>
        <IconButton onClick={openMenu}>
          <DotsVertical />
        </IconButton>
        <Menu
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          classes={{ paper: classes.menu }}
          getContentAnchorEl={null}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={closeMenu}
        >
          <MenuItem onClick={handleOpenCertificate}>Visualizar</MenuItem>
          <MenuItem onClick={closeMenu}>
            <a href={`${props.url}?download=true`} target='_blank' download={true} rel='noreferrer'>
              Baixar
            </a>
          </MenuItem>
        </Menu>
      </div>
    </ShowcaseCard>
  );
};

export default Card;
